'use strict';


const adminMenu = [
  {
    "id": 7,
    "title": "Organisations",
    "route": "/organisations",
    "icon": "fa-university",
    "childActions": [],
    "tooltip": "Organisations",
    "isExternal": false,
    "isToWeb": false
  },
  {
    "id": 8,
    "title": "Modules",
    "route": "/modules",
    "icon": "fa-puzzle-piece",
    "childActions": [
      {
        "id": 2,
        "title": "Reading Assessment",
        "childActions": [
          {
            "id": 1,
            "title": "Books Subscription",
            "route": "/books-subscription",
            "icon": "fa-book",
            "childActions": [],
            "tooltip": "Books Subscription",
            "isExternal": false,
            "isToWeb": false
          }
        ],
        "isExternal": false,
        "isToWeb": false
      },
      {
        "id": 3,
        "title": "Ofsted",
        "childActions": [
          {
            "id": 1,
            "title": "Inspection Coach",
            "route": "/inspection-coach",
            "icon": "fa-book",
            "childActions": [],
            "tooltip": "Inspection Coach",
            "isExternal": false,
            "isToWeb": false
          }
        ],
        "isExternal": false,
        "isToWeb": false
      }
    ],
    "tooltip": "Modules",
    "isExternal": false,
    "isToWeb": false
  },
  {
    "id": 9,
    "title": "Sector Areas",
    "route": "/sector-areas",
    "icon": "fa-list",
    "childActions": [],
    "tooltip": "Sector Areas",
    "isExternal": false,
    "isToWeb": false
  },
  {
    "id": 14,
    "title": "Activity log",
    "route": "/activity-log",
    "icon": "fa-desktop",
    "childActions": [],
    "tooltip": "Activity log",
    "isExternal": false,
    "isToWeb": false
  },
  {
    "id": 10,
    "title": "My profile",
    "route": "/my-profile",
    "icon": "fa-user",
    "childActions": [],
    "tooltip": "My profile",
    "isExternal": false,
    "isToWeb": false
  },
  {
    "id": 11,
    "title": "Logout",
    "route": "/logout",
    "icon": "fa-sign-out",
    "childActions": [],
    "tooltip": "Logout",
    "isExternal": false,
    "isToWeb": false
  }
];

module.exports = {
  adminMenu: Promise.resolve(adminMenu)
};
